module.exports = __webpack_public_path__ + "img/settings_applications.75d98fef.svg";